import type { TOC } from '@ember/component/template-only';

import GenieRoutinesRunComponent from 'webapp/components/genie/routines/run';
import type { RoutineRunModel } from 'webapp/routes/routines/run';

interface Args {
	model: RoutineRunModel;
}

const MobileGenieRoutinesRunRouteTemplate: TOC<Args> = <template>
	<GenieRoutinesRunComponent
		class="mobile-routine-run"
		@routineId={{@model.routineId}}
		@runId={{@model.runId}}
	/>
</template>;

export default MobileGenieRoutinesRunRouteTemplate;
